import { MarketingProfileExportRow } from 'types/marketingProfiles';

export const mapMarketingProfilesToCSVFormat = (rows: MarketingProfileExportRow[]): Record<string, unknown>[] =>
    rows.map((row) => ({
        Email: row.email,
        Name: row.personName,
        'Business Phone': row.phone,
        'Mobile Phone': row.mobilePhone,
        'Company list': row.companyList,
    }));
